/* eslint-disable react-hooks/exhaustive-deps */
// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect, useCallback } from 'react'
import { isEmpty } from 'utils'
import useDidMountEffect from './useDidMountEffect'

const useFormValidation = (initialState, validationSchema, submitForm, onFinish, setOtpModal) => {
  console.log('initial state', initialState)
  const [values, setValues] = useState(initialState)
  console.log('values', values)
  const [errors, setErrors] = useState({})
  const [isSubmitting, setSubmitting] = useState(false)
  const [touched, setTouched] = useState({})
  // const [termsAgreed, setTermsAgreed] = useState(false);
  
  

  useEffect(() => {
    // console.log(values)
    // console.log('isSubmitting', isSubmitting)
    if (isSubmitting) {
      // // console.log(errors)
      if (Object.keys(errors).length === 0) {
        submitForm()
      } else {
        setSubmitting(false)}
    }
  }, [values, errors])
  // }, [values, errors])

  // useDidMountEffect(
  //   () => {
  //     // console.log('in useCallback', touched)
  //     const isTouched = (!Object.values(touched).indexOf(true) === -1)
  //     if (isTouched) validateForm()
  //   },
  //   [values],
  // )
  useDidMountEffect(() => {
    // // console.log('in useDidMountEffect')
    validateForm()
  }, [values])

  const onChange = event => {
    console.log('event value is', event)
    event.persist()
    // let name='';
    // let value='';
    // if (event.files){
    //   name ='mainImage';
    //   value = event.files.fileList[0].originFileObj
    // }
    // else if (event.target.type === "input"){
    //   const {name:a, value:b} = event.target
    //   name=a
    //   value=b
    // }
    // setValues(val => ({ ...val, [name]:value }))
    // // console.log('event.target.type onChange', event.target.type)

    // if (event.target.type === 'file') {
    //   if (fileName) setTouched(a => ({ ...a, [fileName]: true }))
    //   // return
    // }
    // setTouched(event.target)
    
    setValues(val => ({ ...val, [event.target.name]: event.target.value }))
    console.log('event.target.value', event.target.value)
    // if(event.target.name === 'checking') {
    //   setTermsAgreed(event.target.value)
    //   console.log('event.target.value', event.target.value)
    // }
  }

  // useEffect(() => {
  //   validateFormTouched()
  // }, [touched])

  const onSubmit = event => {
    if (event) event.preventDefault()
    validateForm()
    setSubmitting(true)
    
  }

  const onSubmitt = event => {
    if (event) event.preventDefault()
    onFinish()
    
  }


  useEffect(() => {
    // // console.log('useEffect', values)
    if (isEmpty(values)) {
      // // console.log('clearing errors')
      setErrors({})
    }
  }, [values])

  const reset = () => {
    setValues({})
  }

  const validateForm = () => {
    validationSchema
      .validate(values, { abortEarly: false })
      .then(() => {
        
        setErrors({})
      })
      .catch(err => {
        
        
        const errorArray = err.inner.map(e => ({ [e.path]: e.message }))
        const errObject = Object.assign({}, ...errorArray)

        setErrors(errObject)
      })
  }
  // const validateFormTouched = () => {
  //   validationSchema
  //     .validate(values, { abortEarly: false })
  //     .then(a => {
  //       // console.log('values are valid', a)
  //       setErrors({})
  //     })
  //     .catch(err => {
  //       // console.log(values)
  //       // console.log(err)
  //       const errorArray = err.inner.map(e => ({ [e.path]: e.message }))
  //       const errObject = Object.assign({}, ...errorArray)
  //       const a = Object.entries(errObject).map(([k,v])=> (
  //         {[k]: touched[k] ? v : ''}
  //       ))
  //       // console.log(a)
  //       const b = Object.assign({}, ...a)
  //       // console.log(b)
  //       setErrors(b)
  //     })
  // }

  const onBlur = event => {
    event.persist()
    // console.log('event.target.type onBlur', event.target.type)
    validateForm()
    // if (event.target.type === "button") return;
    // setValues(val => ({ ...val, [event.target.name]: event.target.value }))
    // setTouched(a => ({ ...a, [event.target.name]: true }))
  }

  return {
    reset,
    setErrors,
    values,
    setValues,
    onChange,
    onSubmit,
    onSubmitt,
    onBlur,
    isSubmitting,
    errors,
    setSubmitting,
    validateForm,
    touched,
    setTouched,
    // termsAgreed
  }
}

export default useFormValidation
